import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=c8b8e318&scoped=true&"
import script from "./TableActions.vue?vue&type=script&lang=ts&"
export * from "./TableActions.vue?vue&type=script&lang=ts&"
import style0 from "./TableActions.vue?vue&type=style&index=0&id=c8b8e318&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b8e318",
  null
  
)

export default component.exports